import axios from "axios";
import { store } from "../redux/store";
/**
 * 服务器地址
 */
//window.serverUrl = "http://127.0.0.1:8000";
window.serverUrl = "https://service.joemeet.com";
/**
 * 发送post请求
 * @param uri 
 * @param body 
 */
export async function post(uri:string,body:any={}){

    if(!uri.startsWith("/") && !uri.startsWith("http")){
        throw new Error("参数错误;uri必须以 / 或者 http(s) 开头")
    }
    const config = {
        headers: {
            Authorization : `Bearer ${store.getState().account.token}`
        }
    };
    const response = await axios.post(`${window.serverUrl}${uri}`,body,config);
    return response.data;
}

/**
 * 发送get请求，只返回body
 * @param uri get请求地址
 * @param query get查询参数
 */
export async function get(uri:string, query:string = ""){

    if(!uri.startsWith("/") && !uri.startsWith("http")){
        throw new Error("参数错误;uri必须以 / 或者 http(s) 开头")
    }

    let url = uri.startsWith("http")?uri:`${window.serverUrl}${uri}`;
    url = query?`${url}?${query}`:`${url}`;
    const config = {
        headers: {
            Authorization : `Bearer ${store.getState().account.token}`
        }
    };
    const response = await axios.get(url,config);
    return response.data;
}

/**
 * 发送get请求，返回完整的response信息（head body）
 * @param uri get请求地址
 * @param query get查询参数
 */
 export async function getFullResponse(uri:string, query:string = ""){

    if(!uri.startsWith("/") && !uri.startsWith("http")){
        throw new Error("参数错误;uri必须以 / 或者 http(s) 开头")
    }

    let url = uri.startsWith("http")?uri:`${window.serverUrl}${uri}`;
    url = query?`${url}?${query}`:`${url}`;
    const config = {
        headers: {
            Authorization : `Bearer ${store.getState().account.token}`
        }
    };
    const response = await axios.get(url,config);
    console.log("getFullResponse={}",response);
    return response;
}

/**
 * 
 * @param fullUrl 
 * @returns 
 */
export async function getFullUrlWithParams(fullUrl:string){

    const response = await axios.get(fullUrl);
    return response.data;
}